import { gql } from "apollo-angular";
import { ADDRESS_FIELDS_FRAGMENT } from "./address-fragment-definition";
import { BANK_ACCOUNT_FRAGMENT } from "./bank-account.definition";
import { BASEMODEL_FRAGMENT } from "./base-definition";
import { DELETION_RESPONSE_FRAGMENT } from "./system-definition";

export const ADDRESS_BANK_ACCOUNT_LINK_FRAGMENT = gql`
fragment AddressBankAccountLink on AddressBankAccountLink {
    ...IBaseModel
    addressId
    address {
        ...AddressFields
    }
    bankAccountId
    bankAccount {
        ...BankAccount
    }
    isDefault
}
${BASEMODEL_FRAGMENT}
${BANK_ACCOUNT_FRAGMENT}
${ADDRESS_FIELDS_FRAGMENT}
`;

export const GET_ADDRESS_BANK_ACCOUNT_LINK = gql`
query GetAddressBankAccountLink($id: String!) {
    getAddressBankAccountLink(id: $id) {
        ...AddressBankAccountLink
    }
}
${ADDRESS_BANK_ACCOUNT_LINK_FRAGMENT}
`;

export const GET_ADDRESS_BANK_ACCOUNT_LINKS = gql`
query GetAddressBankAccountLinks($searchInput: AddressBankAccountLinkSearchInput) {
    getAddressBankAccountLinks(searchInput: $searchInput) {
        items {
            ...AddressBankAccountLink
        }
        totalItems
    }
}
${ADDRESS_BANK_ACCOUNT_LINK_FRAGMENT}
`;

export const SAVE_ADDRESS_BANK_ACCOUNT_LINK = gql`
mutation SaveAddressBankAccountLink($input: AddressBankAccountLinkInput!) {
    saveAddressBankAccountLink(input: $input) {
        ...AddressBankAccountLink
    }
}
${ADDRESS_BANK_ACCOUNT_LINK_FRAGMENT}
`;

export const DELETE_ADDRESS_BANK_ACCOUNT_LINK = gql`
mutation DeleteAddressBankAccountLink($id: String!) {
    deleteAddressBankAccountLink(id: $id) {
        ...DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;